import React from "react";

import { t } from "i18next";

import MccsLayout from "components/Report/HelperComponents/MCCSLayout";
import { TEST_NAME } from "constants/applicantReport";

const MCCSVoiceCollecction = ({ assessments }) => {
  const title = t("applicantReport.mccsVoiceCollection");
  const subtitle = t("applicantReport.measuresAperson");
  const MCCSVoiceCollecctionData = assessments.find(
    (assessment) => assessment.name === TEST_NAME.MCCS_VOICE_COLLECTION
  );

  return (
    <MccsLayout
      data={MCCSVoiceCollecctionData}
      title={title}
      subtitle={subtitle}
    />
  );
};

export default MCCSVoiceCollecction;
